export default __webpack_public_path__ + "static/media/icon_partner-platinum.4199cf2f.svg";